'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevrondown from '@common/__generated__/icon/SvgChevrondown';
import { Button, DropdownMenu, Radio } from '@common/components';
import { cn } from '@core/utils';
import { useEffect, useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { HOMETOWNS_BUSINESS_SORT_TYPE, HOMETOWNS_BUSINESS_SORT_TYPE_LABEL } from '../constants';
import type { HometownBusinessSortType } from '../types';
interface HometownBusinessFilterProps {
  searchParams: {
    sortType: HometownBusinessSortType;
    institutionId?: number;
  };
  institutionOptions: {
    label: string;
    value: number;
  }[];
}
const SORT_TYPE_OPTIONS = Object.entries(HOMETOWNS_BUSINESS_SORT_TYPE).map(([, value]) => ({
  label: HOMETOWNS_BUSINESS_SORT_TYPE_LABEL[value],
  value
}));
export const HometownBusinessFilter = t0 => {
  const $ = _c(66);
  const {
    searchParams,
    institutionOptions
  } = t0;
  const router = useCustomRouter();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams ?? {};
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sortType,
    institutionId: strInstitutionId
  } = t1;
  let t2;
  if ($[2] !== strInstitutionId) {
    t2 = Number.isNaN(Number(strInstitutionId)) ? undefined : Number(strInstitutionId);
    $[2] = strInstitutionId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const institutionId = t2;
  const [isSortTypeFilterOpen, setIsSortTypeFilterOpen] = useState(false);
  const [isInstitutionFilterOpen, setIsInstitutionFilterOpen] = useState(false);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsSortTypeFilterOpen(false);
      setIsInstitutionFilterOpen(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== institutionId || $[6] !== sortType) {
    t4 = [sortType, institutionId];
    $[5] = institutionId;
    $[6] = sortType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  const t5 = HOMETOWNS_BUSINESS_SORT_TYPE_LABEL[sortType];
  let t6;
  if ($[8] !== institutionId || $[9] !== institutionOptions) {
    t6 = institutionId ? institutionOptions.find(t7 => {
      const {
        value
      } = t7;
      return value === institutionId;
    })?.label : "\uC9C0\uC790\uCCB4";
    $[8] = institutionId;
    $[9] = institutionOptions;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = {
      sortType: t5,
      institution: t6
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const placeHolder = t7;
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("hidden size-fit px-0 py-10 font-400 text-Gray-900 typo-body4", "mobile-tablet:inline-flex");
    t9 = () => setIsSortTypeFilterOpen(true);
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  const t10 = placeHolder.sortType;
  let t11;
  if ($[16] !== isSortTypeFilterOpen) {
    t11 = cn("size-12 duration-150", {
      "rotate-180": isSortTypeFilterOpen
    });
    $[16] = isSortTypeFilterOpen;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <SvgChevrondown className={t11} />;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== placeHolder.sortType || $[21] !== t12) {
    t13 = <Button theme="sub-text" className={t8} onClick={t9}>{t10}{t12}</Button>;
    $[20] = placeHolder.sortType;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = !sortType ? undefined : sortType;
  let t15;
  if ($[23] !== router || $[24] !== searchParams) {
    t15 = value_0 => {
      router.push(DONATION_ROUTES.HOMETOWNS_BUSINESS.withSearchParams({
        searchParams: {
          ...searchParams,
          sortType: !value_0 ? undefined : value_0 as HometownBusinessSortType
        }
      }));
    };
    $[23] = router;
    $[24] = searchParams;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <DropdownMenu options={SORT_TYPE_OPTIONS} value={t14} onChange={t15} type="text" placeholder={"\uC815\uB82C \uAE30\uC900 \uC120\uD0DD"} className="mobile-tablet:hidden" />;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn("hidden size-fit px-0 py-10 font-400 text-Gray-900 typo-body4", "mobile-tablet:inline-flex");
    t18 = () => setIsInstitutionFilterOpen(true);
    $[29] = t17;
    $[30] = t18;
  } else {
    t17 = $[29];
    t18 = $[30];
  }
  const t19 = placeHolder.institution;
  let t20;
  if ($[31] !== isInstitutionFilterOpen) {
    t20 = cn("size-12 duration-150", {
      "rotate-180": isInstitutionFilterOpen
    });
    $[31] = isInstitutionFilterOpen;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t20) {
    t21 = <SvgChevrondown className={t20} />;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== placeHolder.institution || $[36] !== t21) {
    t22 = <Button theme="sub-text" className={t17} onClick={t18}>{t19}{t21}</Button>;
    $[35] = placeHolder.institution;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => {
      setIsSortTypeFilterOpen(false);
    };
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== searchParams || $[40] !== sortType) {
    t24 = SORT_TYPE_OPTIONS.map(t25 => {
      const {
        value: value_1,
        label
      } = t25;
      const convertSortType = !sortType ? "" : sortType;
      const isSelected = convertSortType === value_1;
      return <li key={value_1} className={cn("flex items-center py-9 font-400 text-Gray-900 typo-body3", {
        "font-500": isSelected
      })}><CustomLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.withSearchParams({
          searchParams: {
            ...searchParams,
            sortType: !value_1 ? undefined : value_1 as HometownBusinessSortType
          }
        })} aria-label={"\uC815\uB82C \uBCC0\uACBD"}><Radio.Group value={convertSortType} theme="black"><Radio.Item value={value_1}>{label}</Radio.Item></Radio.Group></CustomLink></li>;
    });
    $[39] = searchParams;
    $[40] = sortType;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t24) {
    t25 = <ul className="flex max-h-220 flex-col overflow-y-auto py-12 [&::-webkit-scrollbar-thumb]:rounded-xxsmall [&::-webkit-scrollbar-thumb]:bg-Gray-300 [&::-webkit-scrollbar]:w-6">{t24}</ul>;
    $[42] = t24;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== isSortTypeFilterOpen || $[45] !== t25) {
    t26 = <ResponsiveDialog opened={isSortTypeFilterOpen} onClose={t23} ariaLabel={"\uC815\uB82C \uC120\uD0DD"} drawerType="bottom">{t25}</ResponsiveDialog>;
    $[44] = isSortTypeFilterOpen;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = () => {
      setIsInstitutionFilterOpen(false);
    };
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== institutionId || $[49] !== institutionOptions || $[50] !== searchParams) {
    let t29;
    if ($[52] !== institutionId || $[53] !== searchParams) {
      t29 = t30 => {
        const {
          value: value_2,
          label: label_0
        } = t30;
        const convertInstitutionId = institutionId ?? 0;
        const isSelected_0 = convertInstitutionId === value_2;
        return <li key={value_2} className={cn("flex items-center py-9 font-400 text-Gray-900 typo-body3", {
          "font-500": isSelected_0
        })}><CustomLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.withSearchParams({
            searchParams: {
              ...searchParams,
              institutionId: value_2 ? value_2 : undefined
            }
          })} aria-label={"\uC9C0\uC790\uCCB4 \uBCC0\uACBD"}><Radio.Group value={convertInstitutionId} theme="black"><Radio.Item value={value_2}>{label_0}</Radio.Item></Radio.Group></CustomLink></li>;
      };
      $[52] = institutionId;
      $[53] = searchParams;
      $[54] = t29;
    } else {
      t29 = $[54];
    }
    t28 = institutionOptions.map(t29);
    $[48] = institutionId;
    $[49] = institutionOptions;
    $[50] = searchParams;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[55] !== t28) {
    t29 = <ul className="flex max-h-220 flex-col overflow-y-auto py-12 [&::-webkit-scrollbar-thumb]:rounded-xxsmall [&::-webkit-scrollbar-thumb]:bg-Gray-300 [&::-webkit-scrollbar]:w-6">{t28}</ul>;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== isInstitutionFilterOpen || $[58] !== t29) {
    t30 = <ResponsiveDialog opened={isInstitutionFilterOpen} onClose={t27} ariaLabel={"\uC9C0\uC790\uCCB4 \uC120\uD0DD"} drawerType="bottom">{t29}</ResponsiveDialog>;
    $[57] = isInstitutionFilterOpen;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t13 || $[61] !== t16 || $[62] !== t22 || $[63] !== t26 || $[64] !== t30) {
    t31 = <div className="flex items-center gap-8">{t13}{t16}{t22}{t26}{t30}</div>;
    $[60] = t13;
    $[61] = t16;
    $[62] = t22;
    $[63] = t26;
    $[64] = t30;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  return t31;
};